// assets/bb-home-carrossel-animado.js
// Antes isto era <script> inline com `let isAnimating_<id>` e `function moveSlide` no
// escopo global (achado #25): duas instâncias na mesma página redeclaravam `moveSlide` e
// o `let` dava SyntaxError, matando o script todo. Agora é um módulo por arquivo, com o
// estado num Map, e os botões acham a seção pelo DOM em vez de receberem o id por string.
// Cada instância da seção emite o próprio <script defer>, então este arquivo roda uma vez por
// instância: a trava data-bb-carrossel-pronto liga cada seção uma vez só.
(() => {
  const animando = new Map();

  function updateDots(element) {
    const scrollLeft = element.scrollLeft;
    const width = element.clientWidth;
    const pageIndex = Math.round(scrollLeft / width);
    const dotsContainers = element.parentElement.querySelectorAll('.m-dots');
    dotsContainers.forEach((container) => {
      const dots = container.querySelectorAll('.m-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === pageIndex);
      });
    });
  }

  document.querySelectorAll('[data-carrossel-animado]').forEach((secao) => {
    if (secao.hasAttribute('data-bb-carrossel-pronto')) return;
    secao.setAttribute('data-bb-carrossel-pronto', '');
    const container = secao.querySelector('[data-slides]');
    if (!container) return;

    const moveSlide = (direction) => {
      if (animando.get(secao)) return;
      animando.set(secao, true);

      const slides = container.querySelectorAll('.slide-item');

      let activeIndex = Array.from(slides).findIndex((slide) => slide.classList.contains('active'));
      let nextIndex = activeIndex + direction;

      if (nextIndex >= slides.length) nextIndex = 0;
      if (nextIndex < 0) nextIndex = slides.length - 1;

      const currentSlide = slides[activeIndex];
      const nextSlide = slides[nextIndex];

      currentSlide.classList.add('slide-out-down');
      setTimeout(() => {
        currentSlide.classList.remove('active', 'slide-out-down');

        const newBg = nextSlide.getAttribute('data-bg');
        if (newBg && newBg.trim() !== '') {
          // custom property, não style.backgroundImage: inline venceria a regra mobile do CSS
          secao.style.setProperty('--bg-desktop', `url('${newBg}')`);
        }

        const newBgMobile = nextSlide.getAttribute('data-bg-mobile');
        if (newBgMobile && newBgMobile.trim() !== '') {
          secao.style.setProperty('--bg-mobile', `url('${newBgMobile}')`);
        }

        nextSlide.classList.add('active', 'slide-in-top');

        const mScroller = nextSlide.querySelector('.m-scroller');
        if (mScroller) {
          mScroller.scrollLeft = 0;
          const dotsContainers = nextSlide.querySelectorAll('.m-dots');
          dotsContainers.forEach((dotsContainer) => {
            const dots = dotsContainer.querySelectorAll('.m-dot');
            dots.forEach((dot, idx) => dot.classList.toggle('active', idx === 0));
          });
        }

        setTimeout(() => {
          nextSlide.classList.remove('slide-in-top');
          animando.set(secao, false);
        }, 500);
      }, 500);
    };

    // um par de setas por slide (dentro do for do Liquid): liga todas
    secao.querySelectorAll('[data-slide-prev]').forEach((btn) => btn.addEventListener('click', () => moveSlide(-1)));
    secao.querySelectorAll('[data-slide-next]').forEach((btn) => btn.addEventListener('click', () => moveSlide(1)));

    secao.querySelectorAll('[data-m-scroller]').forEach((scroller) => {
      scroller.addEventListener('scroll', () => updateDots(scroller));
    });
  });
})();
